import loadable from '@loadable/component';

export const CircleInformation = loadable(() => import('./CircleInformation'));
export const CircleApplication = loadable(() => import('./CircleApplication'));
